import React, { useState, useEffect, useRef } from 'react';

function DropdownCheckboxList({ items, selectedItems, onChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleCheckboxChange = (item) => {
        const newSelectedItems = selectedItems.includes(item)
            ? selectedItems.filter(i => i !== item)
            : [...selectedItems, item];

        onChange(newSelectedItems);
    };

    const handleSelectAll = () => {
        if (selectedItems.length === items.length) {
            onChange([]); // Deselect all
        } else {
            onChange(items); // Select all
        }
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Sort items alphabetically before rendering
    const sortedItems = items.sort((a, b) => a.localeCompare(b));

    // Determine if "All" checkbox should be checked
    const isAllSelected = selectedItems.length === items.length;

    return (
        <div className="relative inline-block text-left" ref={dropdownRef}>
            <div>
                <button
                    type="button"
                    className="p-3 inline-flex justify-between items-center rounded-lg border border-gray-300 px-4 py-2 bg-white text-sm font-semibold text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onClick={toggleDropdown}
                >
                    Countries
                    <svg
                        className={`ml-2 w-4 h-4 transform ${isOpen ? 'rotate-180' : ''}`}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                        />
                    </svg>
                </button>
            </div>

            {isOpen && (
                <div className="origin-top-right absolute right-0 mt-2 w-64 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5 overflow-hidden">
                    <div className="py-1 divide-y divide-slate-200">
                        <label className="flex items-center px-4 py-2 text-gray-700 cursor-pointer hover:bg-gray-50">
                            <input
                                type="checkbox"
                                checked={isAllSelected}
                                onChange={handleSelectAll}
                                className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500"
                            />
                            <span className="text-sm">All</span>
                        </label>
                        {sortedItems.map((item, index) => (
                            <label
                                key={index}
                                className="flex items-center px-4 py-2 text-gray-700 cursor-pointer hover:bg-gray-50"
                            >
                                <input
                                    type="checkbox"
                                    checked={selectedItems.includes(item)}
                                    onChange={() => handleCheckboxChange(item)}
                                    className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500"
                                />
                                <span className="text-sm">{item}</span>
                            </label>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default DropdownCheckboxList;
